import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@instructure/ui-checkbox';
import { IconButton } from '@instructure/ui-buttons';
import { IconInfoLine as IconInfo } from '@instructure/ui-icons';
import { Tooltip } from '@instructure/ui-tooltip';
import { View } from '@instructure/ui-view';
import t from '@instructure/quiz-i18n/format-message';
export var ReduceAnswerChoicesSettings = /*#__PURE__*/function (_Component) {
  function ReduceAnswerChoicesSettings() {
    var _this2;
    _classCallCheck(this, ReduceAnswerChoicesSettings);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ReduceAnswerChoicesSettings, [].concat(args));
    _defineProperty(_this2, "onChangeReduceChoices", function () {
      var update = _objectSpread(_objectSpread({}, _this2.props.courseAccommodationSettings), {}, {
        reduceChoicesEnabled: !_this2.props.courseAccommodationSettings.reduceChoicesEnabled
      });
      _this2.props.onChange(update);
    });
    _defineProperty(_this2, "renderSettingLabel", function (label, tooltip) {
      return /*#__PURE__*/React.createElement("span", null, label, /*#__PURE__*/React.createElement(Tooltip, {
        color: "primary-inverse",
        renderTip: tooltip,
        placement: "bottom",
        on: ['click', 'hover', 'focus']
      }, /*#__PURE__*/React.createElement(IconButton, {
        renderIcon: IconInfo,
        color: "secondary",
        size: "small",
        shape: "circle",
        withBackground: false,
        withBorder: false,
        interaction: "readonly",
        screenReaderLabel: tooltip
      })));
    });
    return _this2;
  }
  _inherits(ReduceAnswerChoicesSettings, _Component);
  return _createClass(ReduceAnswerChoicesSettings, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(View, {
        display: "block"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        variant: "toggle",
        checked: this.props.courseAccommodationSettings.reduceChoicesEnabled || false,
        label: this.renderSettingLabel(t('Reduced answer choices'), t('Removes one incorrect answer from all multiple-choice questions that have 4 or more answer choices.')),
        onChange: this.onChangeReduceChoices,
        value: "reduce_choices_enabled"
      }));
    }
  }]);
}(Component);
_defineProperty(ReduceAnswerChoicesSettings, "propTypes", {
  courseAccommodationSettings: PropTypes.shape({
    reduceChoicesEnabled: PropTypes.bool
  }).isRequired,
  onChange: PropTypes.func.isRequired
});
_defineProperty(ReduceAnswerChoicesSettings, "defaultProps", {
  courseAccommodationSettings: {
    reduceChoicesEnabled: false
  }
});
export default ReduceAnswerChoicesSettings;